import React, { type FC } from 'react';

export const RebrandedDateSvg: FC = () => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M7.4974 8.1224C7.4974 8.81275 6.93775 9.3724 6.2474 9.3724C5.55704 9.3724 4.9974 8.81275 4.9974 8.1224C4.9974 7.43204 5.55704 6.8724 6.2474 6.8724C6.93775 6.8724 7.4974 7.43204 7.4974 8.1224Z"
                fill="#161719"
            />
            <path
                d="M9.9974 9.3724C10.6878 9.3724 11.2474 8.81275 11.2474 8.1224C11.2474 7.43204 10.6878 6.8724 9.9974 6.8724C9.30704 6.8724 8.7474 7.43204 8.7474 8.1224C8.7474 8.81275 9.30704 9.3724 9.9974 9.3724Z"
                fill="#161719"
            />
            <path
                d="M14.9974 8.1224C14.9974 8.81275 14.4378 9.3724 13.7474 9.3724C13.057 9.3724 12.4974 8.81275 12.4974 8.1224C12.4974 7.43204 13.057 6.8724 13.7474 6.8724C14.4378 6.8724 14.9974 7.43204 14.9974 8.1224Z"
                fill="#161719"
            />
            <path
                d="M6.2474 13.1224C6.93775 13.1224 7.4974 12.5628 7.4974 11.8724C7.4974 11.182 6.93775 10.6224 6.2474 10.6224C5.55704 10.6224 4.9974 11.182 4.9974 11.8724C4.9974 12.5628 5.55704 13.1224 6.2474 13.1224Z"
                fill="#161719"
            />
            <path
                d="M11.2474 11.8724C11.2474 12.5628 10.6878 13.1224 9.9974 13.1224C9.30704 13.1224 8.7474 12.5628 8.7474 11.8724C8.7474 11.182 9.30704 10.6224 9.9974 10.6224C10.6878 10.6224 11.2474 11.182 11.2474 11.8724Z"
                fill="#161719"
            />
            <path
                d="M13.7474 13.1224C14.4378 13.1224 14.9974 12.5628 14.9974 11.8724C14.9974 11.182 14.4378 10.6224 13.7474 10.6224C13.057 10.6224 12.4974 11.182 12.4974 11.8724C12.4974 12.5628 13.057 13.1224 13.7474 13.1224Z"
                fill="#161719"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.2474 1.66406H7.91406V2.4974H12.0807V1.66406H13.7474V2.4974H18.3307V17.4974H1.66406V2.4974H6.2474V1.66406ZM6.2474 4.16406H3.33073V15.8307H16.6641V4.16406H13.7474V4.9974H12.0807V4.16406H7.91406V4.9974H6.2474V4.16406Z"
                fill="#161719"
            />
        </svg>
    );
};
